import { Invoice } from "./invoice";
import { Receipt } from "./receipt";
import { SystemField } from "./system-field";

export class InvoiceReceipt extends SystemField { 
     invoices_id?:string;
     receipts_id?:string;
     amount?:number;

     //relationship
     invoice?: Invoice;
     receipt?:Receipt;
}
